export default "__VITE_ASSET__X$SGQp2r__"